
export default {
  data() {
    return {
      value: null
    };
  },
  props: {
    field: {
      type: Object,
      required: true
    }
  },
  watch: {
    "field.value": {
      immediate: true,
      handler() {
        this.value = this.field.get(true);
      }
    }
  },
  computed: {
    url() {
      if (this.value) return this.field.property.fileUrl;
      return false;
    }
  }
};
